export default __webpack_public_path__ + "static/media/gus-salock.743a27a5.png";